module.exports = __webpack_public_path__ + "fonts/sacramento.0c8e69ac.ttf";